var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlatRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 170,
    viewBox: "0 0 200 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 48L27 60V70L67.5 60L88.5 68L110 64.5L67.5 48Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 122H33V68.5L66 60V122ZM66 122H73",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 61L66 73.5V83.5L128.5 75M128.5 61L173.5 78V87H168.5L128.5 75M128.5 61V75",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73 83L128 75V122H73V83Z",
    stroke: "#FF0000",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168 87L128 75V122H168V87Z",
    stroke: "#FF0000",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8586 97.0101C81.3659 97.0804 81 97.5023 81 98V109C81 109.29 81.1258 109.566 81.3448 109.755C81.5638 109.945 81.8544 110.031 82.1414 109.99L89.1414 108.99C89.6341 108.92 90 108.498 90 108V97C90 96.7101 89.8742 96.4345 89.6552 96.2445C89.4362 96.0546 89.1456 95.9691 88.8586 96.0101L81.8586 97.0101Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6702 94.5016C45.2688 94.6418 45 95.0205 45 95.4457V120C45 120.268 45.1073 120.524 45.2979 120.712C45.4884 120.9 45.7464 121.004 46.014 121L53.014 120.902C53.5608 120.894 54 120.449 54 119.902V93C54 92.676 53.843 92.3721 53.5789 92.1846C53.3147 91.997 52.976 91.9491 52.6702 92.056L45.6702 94.5016Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8586 95.0101C96.3659 95.0804 96 95.5023 96 96V107C96 107.29 96.1258 107.566 96.3448 107.755C96.5638 107.945 96.8544 108.031 97.1414 107.99L104.141 106.99C104.634 106.92 105 106.498 105 106V95C105 94.7101 104.874 94.4345 104.655 94.2445C104.436 94.0546 104.146 93.9691 103.859 94.0101L96.8586 95.0101Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.859 93.0101C111.366 93.0804 111 93.5023 111 94V106C111 106.29 111.126 106.566 111.345 106.755C111.564 106.945 111.854 107.031 112.141 106.99L119.141 105.99C119.634 105.92 120 105.498 120 105V93C120 92.7101 119.874 92.4345 119.655 92.2445C119.436 92.0546 119.146 91.9691 118.859 92.0101L111.859 93.0101Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatRoof);
export default __webpack_public_path__ + "static/media/FlatRoof.0181d0a6288668b79959ed0c5304897d.svg";
export { ForwardRef as ReactComponent };